export const isBlank = (value?: string | number | null): boolean => {
  if (value === null || value === undefined || value === '') return true;
  if (typeof value === 'number') return Number.isNaN(value);
  return /^\s*$/.test(value);
};
